import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';

export const ModalStyled = styled(Modal)`

  backdrop-filter: blur(2px);

  hr {
    margin: 0px;
    padding: 0px;
  }

  .modal-content{
    border-radius: 6px;
    padding: 28px 39px;
    background-color: #fff;
  }  

  .modal-header {
    padding: 0;
    border: none;
    justify-content: center;
  }
  .modal-body {
    padding: 0;
    justify-content: center;
  }

  .modal-328 {
    min-width: 328px;
    @media (min-width: 576px) {
      max-width: 328px;
      margin: 1.75rem auto;
    }
  }

  .close {
    color: #bbc8db;
    border: 3px solid #bbc8db;
    border-radius: 50%;
    padding: 0px;
    margin: 0px;
    width: 24px;
    height: 24px;
    position: relative;
    span {
      font-size: 22px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    font-size: 20px;
  }
  .modal-title {
    color: #6C757D;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 450;
    line-height: 20px;
    margin-bottom: 20px;
    justify-content: center;
  }
`;
